import { Box } from 'dash-ui';

import { TopRowWidgetsWraper } from 'pages/Dashboard/components/TopRowWidgets/TopRowWidgets.style';
import DashboardWidgetPropertySave from 'common/components/DashboardWidgetPropertySave/DashboardWidgetPropertySave';
import DashboardWidgetPropertyShare from 'common/components/DashboardWidgetPropertyShare/DashboardWidgetPropertyShare';
import DashboardWidgetPropertyAddedPortfolio from 'common/components/DashboardWidgetPropertyAddedPortfolio/DashboardWidgetPropertyAddedPortfolio';
import DashboardWidgetPropertyMediakit from 'common/components/DashboardWidgetPropertyMediakit/DashboardWidgetPropertyMediakit';

const TopRowWidgets = () => {
  return (
    <TopRowWidgetsWraper>
      <Box w="100%" h="100%">
        <DashboardWidgetPropertyMediakit />
      </Box>
      <Box w="100%" h="100%" mx={4}>
        <DashboardWidgetPropertySave />
      </Box>
      <Box w="100%" h="100%" mr={4}>
        <DashboardWidgetPropertyShare />
      </Box>
      <Box w="100%" h="100%">
        <DashboardWidgetPropertyAddedPortfolio />
      </Box>
    </TopRowWidgetsWraper>
  );
};

export default TopRowWidgets;
